export type TokenPrimitive = string | number;
export type FlatTokenMap = Record<string, TokenPrimitive>;

export const themeRaw: FlatTokenMap = {
  'color/accent': '#6ae8c5',
  'color/neutral': '#48546c',
  'color/success': '#6ae8c5',
  'color/warning': '#fad10f',
  'color/error': '#de2d2c',
  'color/info': '#5c8bd7',
  'color/accent/accent-0': '#ffffff',
  'color/accent/accent-50': '#f0fdf9',
  'color/accent/accent-100': '#e1faf3',
  'color/accent/accent-200': '#c3f6e8',
  'color/accent/accent-300': '#a6f1dc',
  'color/accent/accent-400': '#88edd1',
  'color/accent/accent-500': '#6ae8c5',
  'color/accent/accent-600': '#55ba9e',
  'color/accent/accent-700': '#408b76',
  'color/accent/accent-800': '#2a5d4f',
  'color/accent/accent-900': '#1d3f35',
  'color/accent/accent-950': '#142924',
  'color/accent/accent-1000': '#000000',
  'color/neutral/neutral-0': '#ffffff',
  'color/neutral/neutral-50': '#f4f4f6',
  'color/neutral/neutral-100': '#e2e5e9',
  'color/neutral/neutral-950': '#14171f',
  'color/neutral/neutral-1000': '#000000',
  'color/neutral/neutral-200': '#c1c5cd',
  'color/neutral/neutral-300': '#9ca2b0',
  'color/neutral/neutral-400': '#717a8e',
  'color/neutral/neutral-500': '#48546c',
  'color/neutral/neutral-600': '#3e475b',
  'color/neutral/neutral-700': '#333b4d',
  'color/neutral/neutral-800': '#29303d',
  'color/neutral/neutral-900': '#1e242f',
  'color/success/success-0': '#ffffff',
  'color/warning/warning-0': '#ffffff',
  'color/error/error-0': '#ffffff',
  'color/info/info-0': '#ffffff',
  'color/success/success-50': '#f0fdf9',
  'color/success/success-100': '#e1faf3',
  'color/success/success-200': '#c3f6e8',
  'color/success/success-300': '#a6f1dc',
  'color/success/success-400': '#88edd1',
  'color/success/success-500': '#6ae8c5',
  'color/success/success-600': '#55ba9e',
  'color/success/success-700': '#408b76',
  'color/success/success-800': '#2a5d4f',
  'color/success/success-900': '#1d3f35',
  'color/success/success-950': '#142924',
  'color/success/success-1000': '#000000',
  'color/warning/warning-50': '#fffbe8',
  'color/warning/warning-100': '#fef6d0',
  'color/warning/warning-200': '#fdefaa',
  'color/warning/warning-300': '#fce887',
  'color/warning/warning-400': '#fbde55',
  'color/warning/warning-500': '#fad10f',
  'color/warning/warning-600': '#d9b611',
  'color/warning/warning-700': '#a58b0d',
  'color/warning/warning-800': '#7b670a',
  'color/warning/warning-900': '#4c3f06',
  'color/warning/warning-950': '#2f2704',
  'color/warning/warning-1000': '#000000',
  'color/error/error-50': '#f7e8e8',
  'color/error/error-100': '#f5bebe',
  'color/error/error-200': '#f09e9e',
  'color/error/error-300': '#eb7f7f',
  'color/error/error-400': '#e76160',
  'color/error/error-500': '#de2d2c',
  'color/error/error-600': '#c02726',
  'color/error/error-700': '#9e201f',
  'color/error/error-800': '#7a1918',
  'color/error/error-900': '#5d1312',
  'color/error/error-950': '#2b0908',
  'color/error/error-1000': '#000000',
  'color/info/info-50': '#eff3fb',
  'color/info/info-100': '#ccdbf3',
  'color/info/info-200': '#b4caed',
  'color/info/info-300': '#92b1e4',
  'color/info/info-400': '#7da2df',
  'color/info/info-500': '#5c8bd7',
  'color/info/info-600': '#547ec4',
  'color/info/info-700': '#416399',
  'color/info/info-800': '#334c76',
  'color/info/info-900': '#253755',
  'color/info/info-950': '#172235',
  'color/info/info-1000': '#000000',
  'spacing/4px': 4,
  'spacing/8px': 8,
  'spacing/16px': 16,
  'spacing/24px': 24,
  'spacing/32px': 32,
  'spacing/40px': 40,
  'spacing/64px': 64,
  'spacing/80px': 80,
  'border-radius/none': 0,
  'border-radius/s': 2,
  'border-radius/m': 4,
  'border-radius/l': 8,
  'border-radius/xl': 16,
  'border-radius/full': 9999,
  'spacing/12px': 12,
  'spacing/2px': 2,
  'spacing/none': 0,
} as const;

export const modeLightRaw: FlatTokenMap = {
  'fg/default': '$theme/color/neutral/neutral-950',
  'fg/soft': '$theme/color/neutral/neutral-500',
  'fg/muted': '$theme/color/neutral/neutral-300',
  'fg/disabled': '$theme/color/neutral/neutral-100',
  'bg/surface1': '$theme/color/neutral/neutral-0',
  'bg/surface2': '#f8f8f8',
  'bg/surface3': '$theme/color/neutral/neutral-100',
  'bg/surface4': '$theme/color/neutral/neutral-200',
  'bg/page': '$theme/color/neutral/neutral-0',
  'bg/page-filled': '$theme/color/neutral/neutral-50',
  'border/default': '$theme/color/neutral/neutral-200',
  'border/soft': '$theme/color/neutral/neutral-100',
  'border/muted': '$theme/color/neutral/neutral-50',
  'border/contrast': '$theme/color/neutral/neutral-800',
  'accent/default': '$theme/color/accent/accent-500',
  'accent/soft': '$theme/color/accent/accent-400',
  'accent/muted': '$theme/color/accent/accent-300',
  'accent/hover': '$theme/color/accent/accent-600',
  'accent/active': '$theme/color/accent/accent-700',
  'accent/on-accent': '$theme/color/accent/accent-900',
  'neutral/default': '$theme/color/neutral/neutral-500',
  'neutral/soft': '$theme/color/neutral/neutral-400',
  'neutral/muted': '$theme/color/neutral/neutral-300',
  'neutral/hover': '$theme/color/neutral/neutral-600',
  'neutral/active': '$theme/color/neutral/neutral-700',
  'neutral/on-neutral': '$theme/color/neutral/neutral-0',
  'success/default': '$theme/color/success/success-500',
  'success/soft': '$theme/color/success/success-400',
  'success/muted': '$theme/color/success/success-300',
  'success/hover': '$theme/color/success/success-600',
  'success/active': '$theme/color/success/success-700',
  'success/on-success': '$theme/color/success/success-900',
  'warning/default': '$theme/color/warning/warning-500',
  'warning/soft': '$theme/color/warning/warning-400',
  'warning/muted': '$theme/color/warning/warning-300',
  'warning/hover': '$theme/color/warning/warning-600',
  'warning/active': '$theme/color/warning/warning-700',
  'warning/on-warning': '$theme/color/warning/warning-900',
  'error/default': '$theme/color/error/error-500',
  'error/soft': '$theme/color/error/error-400',
  'error/muted': '$theme/color/error/error-300',
  'error/hover': '$theme/color/error/error-600',
  'error/active': '$theme/color/error/error-700',
  'error/on-error': '$theme/color/error/error-0',
  'info/default': '$theme/color/info/info-500',
  'info/soft': '$theme/color/info/info-400',
  'info/muted': '$theme/color/info/info-300',
  'info/hover': '$theme/color/info/info-600',
  'info/active': '$theme/color/info/info-700',
  'info/on-info': '$theme/color/info/info-0',
  'info/container-default': '$theme/color/info/info-200',
  'info/container-soft': '$theme/color/info/info-100',
  'info/container-muted': '$theme/color/info/info-50',
  'info/container-hover': '$theme/color/info/info-300',
  'info/container-active': '$theme/color/info/info-400',
  'info/on-container': '$theme/color/info/info-800',
  'warning/container-default': '$theme/color/warning/warning-200',
  'warning/container-soft': '$theme/color/warning/warning-100',
  'warning/container-muted': '$theme/color/warning/warning-50',
  'warning/container-hover': '$theme/color/warning/warning-300',
  'warning/container-active': '$theme/color/warning/warning-400',
  'warning/on-container': '$theme/color/warning/warning-800',
  'error/container-default': '$theme/color/error/error-200',
  'error/container-soft': '$theme/color/error/error-100',
  'error/container-muted': '$theme/color/error/error-50',
  'error/container-hover': '$theme/color/error/error-300',
  'error/container-active': '$theme/color/error/error-400',
  'error/on-container': '$theme/color/error/error-800',
  'success/container-default': '$theme/color/success/success-200',
  'success/container-soft': '$theme/color/success/success-100',
  'success/container-muted': '$theme/color/success/success-50',
  'success/container-hover': '$theme/color/success/success-300',
  'success/container-active': '$theme/color/success/success-400',
  'success/on-container': '$theme/color/success/success-800',
  'neutral/container-default': '$theme/color/neutral/neutral-200',
  'neutral/container-soft': '$theme/color/neutral/neutral-100',
  'neutral/container-muted': '$theme/color/neutral/neutral-50',
  'neutral/container-hover': '$theme/color/neutral/neutral-300',
  'neutral/container-active': '$theme/color/neutral/neutral-400',
  'neutral/on-container': '$theme/color/neutral/neutral-800',
  'accent/container-default': '$theme/color/accent/accent-200',
  'accent/container-soft': '$theme/color/accent/accent-100',
  'accent/container-muted': '$theme/color/accent/accent-50',
  'accent/container-hover': '$theme/color/accent/accent-300',
  'accent/container-active': '$theme/color/accent/accent-400',
  'accent/on-container': '$theme/color/accent/accent-800',
} as const;

export const modeDarkRaw: FlatTokenMap = {
  'fg/default': '$theme/color/neutral/neutral-0',
  'fg/soft': '$theme/color/neutral/neutral-200',
  'fg/muted': '$theme/color/neutral/neutral-300',
  'fg/disabled': '$theme/color/neutral/neutral-700',
  'bg/surface1': '$theme/color/neutral/neutral-950',
  'bg/surface2': '$theme/color/neutral/neutral-900',
  'bg/surface3': '$theme/color/neutral/neutral-800',
  'bg/surface4': '$theme/color/neutral/neutral-700',
  'bg/page': '$theme/color/accent/accent-950',
  'bg/page-filled': '$theme/color/neutral/neutral-900',
  'border/default': '$theme/color/neutral/neutral-1000',
  'border/soft': '$theme/color/neutral/neutral-1000',
  'border/muted': '$theme/color/neutral/neutral-1000',
  'border/contrast': '$theme/color/neutral/neutral-1000',
  'accent/default': '$theme/color/neutral/neutral-1000',
  'accent/soft': '$theme/color/neutral/neutral-1000',
  'accent/muted': '$theme/color/neutral/neutral-1000',
  'accent/hover': '$theme/color/neutral/neutral-1000',
  'accent/active': '$theme/color/neutral/neutral-1000',
  'accent/on-accent': '$theme/color/neutral/neutral-1000',
  'neutral/default': '$theme/color/neutral/neutral-1000',
  'neutral/soft': '$theme/color/neutral/neutral-1000',
  'neutral/muted': '$theme/color/neutral/neutral-1000',
  'neutral/hover': '$theme/color/neutral/neutral-1000',
  'neutral/active': '$theme/color/neutral/neutral-1000',
  'neutral/on-neutral': '$theme/color/neutral/neutral-1000',
  'success/default': '$theme/color/neutral/neutral-1000',
  'success/soft': '$theme/color/neutral/neutral-1000',
  'success/muted': '$theme/color/neutral/neutral-1000',
  'success/hover': '$theme/color/neutral/neutral-1000',
  'success/active': '$theme/color/neutral/neutral-1000',
  'success/on-success': '$theme/color/neutral/neutral-1000',
  'warning/default': '$theme/color/neutral/neutral-1000',
  'warning/soft': '$theme/color/neutral/neutral-1000',
  'warning/muted': '$theme/color/neutral/neutral-1000',
  'warning/hover': '$theme/color/neutral/neutral-1000',
  'warning/active': '$theme/color/neutral/neutral-1000',
  'warning/on-warning': '$theme/color/neutral/neutral-1000',
  'error/default': '$theme/color/neutral/neutral-1000',
  'error/soft': '$theme/color/neutral/neutral-1000',
  'error/muted': '$theme/color/neutral/neutral-1000',
  'error/hover': '$theme/color/neutral/neutral-1000',
  'error/active': '$theme/color/neutral/neutral-1000',
  'error/on-error': '$theme/color/neutral/neutral-1000',
  'info/default': '$theme/color/neutral/neutral-1000',
  'info/soft': '$theme/color/neutral/neutral-1000',
  'info/muted': '$theme/color/neutral/neutral-1000',
  'info/hover': '$theme/color/neutral/neutral-1000',
  'info/active': '$theme/color/neutral/neutral-1000',
  'info/on-info': '$theme/color/neutral/neutral-1000',
  'info/container-default': '$theme/color/neutral/neutral-1000',
  'info/container-soft': '$theme/color/neutral/neutral-1000',
  'info/container-muted': '$theme/color/neutral/neutral-1000',
  'info/container-hover': '$theme/color/neutral/neutral-1000',
  'info/container-active': '$theme/color/neutral/neutral-1000',
  'info/on-container': '$theme/color/neutral/neutral-1000',
  'warning/container-default': '$theme/color/neutral/neutral-1000',
  'warning/container-soft': '$theme/color/neutral/neutral-1000',
  'warning/container-muted': '$theme/color/neutral/neutral-1000',
  'warning/container-hover': '$theme/color/neutral/neutral-1000',
  'warning/container-active': '$theme/color/neutral/neutral-1000',
  'warning/on-container': '$theme/color/neutral/neutral-1000',
  'error/container-default': '$theme/color/neutral/neutral-1000',
  'error/container-soft': '$theme/color/neutral/neutral-1000',
  'error/container-muted': '$theme/color/neutral/neutral-1000',
  'error/container-hover': '$theme/color/neutral/neutral-1000',
  'error/container-active': '$theme/color/neutral/neutral-1000',
  'error/on-container': '$theme/color/neutral/neutral-1000',
  'success/container-default': '$theme/color/neutral/neutral-1000',
  'success/container-soft': '$theme/color/neutral/neutral-1000',
  'success/container-muted': '$theme/color/neutral/neutral-1000',
  'success/container-hover': '$theme/color/neutral/neutral-1000',
  'success/container-active': '$theme/color/neutral/neutral-1000',
  'success/on-container': '$theme/color/neutral/neutral-1000',
  'neutral/container-default': '$theme/color/neutral/neutral-1000',
  'neutral/container-soft': '$theme/color/neutral/neutral-1000',
  'neutral/container-muted': '$theme/color/neutral/neutral-1000',
  'neutral/container-hover': '$theme/color/neutral/neutral-1000',
  'neutral/container-active': '$theme/color/neutral/neutral-1000',
  'neutral/on-container': '$theme/color/neutral/neutral-1000',
  'accent/container-default': '$theme/color/neutral/neutral-1000',
  'accent/container-soft': '$theme/color/neutral/neutral-1000',
  'accent/container-muted': '$theme/color/neutral/neutral-1000',
  'accent/container-hover': '$theme/color/neutral/neutral-1000',
  'accent/container-active': '$theme/color/neutral/neutral-1000',
  'accent/on-container': '$theme/color/neutral/neutral-1000',
} as const;

export const componentsRaw: FlatTokenMap = {
  'badge/primary/info-bg': '$mode/info/default',
  'badge/primary/info-label': '$mode/info/on-info',
  'badge/primary/info-caption': '$mode/info/container-default',
  'badge/secondary/info-bg': '$mode/info/container-default',
  'badge/secondary/info-label': '$mode/info/on-container',
  'badge/secondary/info-caption': '$mode/info/default',
  'badge/tertiary/info-bg': '$mode/info/container-muted',
  'badge/tertiary/info-label': '$mode/info/default',
  'badge/tertiary/info-caption': '$mode/info/soft',
  'badge/primary/warning-bg': '$mode/warning/default',
  'badge/primary/warning-label': '$mode/warning/on-warning',
  'badge/primary/warning-caption': '$mode/warning/on-container',
  'badge/secondary/warning-bg': '$mode/warning/container-default',
  'badge/secondary/warning-label': '$mode/warning/on-container',
  'badge/secondary/warning-caption': '$mode/warning/on-container',
  'badge/tertiary/warning-bg': '$mode/warning/container-muted',
  'badge/tertiary/warning-label': '$mode/warning/on-container',
  'badge/tertiary/warning-caption': '$mode/warning/on-container',
  'badge/primary/error-bg': '$mode/error/default',
  'badge/primary/error-label': '$mode/error/on-error',
  'badge/primary/error-caption': '$mode/error/container-soft',
  'badge/secondary/error-caption': '$mode/error/on-container',
  'badge/secondary/error-label': '$mode/error/on-container',
  'badge/secondary/error-bg': '$mode/error/container-default',
  'badge/tertiary/error-caption': '$mode/error/soft',
  'badge/tertiary/error-label': '$mode/error/default',
  'badge/tertiary/error-bg': '$mode/error/container-muted',
  'badge/primary/success-bg': '$mode/success/default',
  'badge/primary/success-label': '$mode/success/on-success',
  'badge/primary/success-caption': '$mode/success/on-container',
  'badge/secondary/success-caption': '$mode/success/on-container',
  'badge/secondary/success-label': '$mode/success/on-container',
  'badge/secondary/success-bg': '$mode/success/container-default',
  'badge/tertiary/success-caption': '$mode/success/on-container',
  'badge/tertiary/success-label': '$mode/success/on-container',
  'badge/tertiary/success-bg': '$mode/success/container-muted',
  'badge/primary/neutral-caption': '$mode/neutral/container-default',
  'badge/primary/neutral-label': '$mode/neutral/on-neutral',
  'badge/primary/neutral-bg': '$mode/neutral/default',
  'badge/secondary/neutral-caption': '$mode/neutral/default',
  'badge/secondary/neutral-label': '$mode/neutral/on-container',
  'badge/secondary/neutral-bg': '$mode/neutral/container-default',
  'badge/tertiary/neutral-label': '$mode/neutral/default',
  'badge/tertiary/neutral-caption': '$mode/neutral/soft',
  'badge/tertiary/neutral-bg': '$mode/neutral/container-soft',
  'badge/white/neutral-bg': '$mode/neutral/on-neutral',
  'badge/white/neutral-label': '$mode/neutral/default',
  'badge/white/neutral-caption': '$mode/neutral/soft',
  'button/primary/neutral-bg': '$mode/neutral/default',
  'button/primary/neutral-label': '$mode/neutral/on-neutral',
  'button/primary/neutral-hover': '$mode/neutral/hover',
  'button/primary/error-bg': '$mode/error/default',
  'button/primary/error-label': '$mode/error/on-error',
  'button/primary/error-hover': '$mode/error/hover',
  'button/primary/accent-bg': '$mode/accent/default',
  'button/primary/accent-label': '$mode/accent/on-accent',
  'button/primary/accent-hover': '$mode/accent/hover',
  'button/disabled/disabled-bg': '$mode/neutral/container-soft',
  'button/disabled/disabled-label': '$mode/neutral/container-default',
  'button/secondary/accent-bg': '$mode/accent/container-default',
  'button/secondary/accent-label': '$mode/accent/on-container',
  'button/secondary/accent-hover': '$mode/accent/container-hover',
  'button/secondary/neutral-bg': '$mode/neutral/container-default',
  'button/secondary/neutral-label': '$mode/neutral/on-container',
  'button/secondary/neutral-hover': '$mode/neutral/container-hover',
  'button/secondary/error-bg': '$mode/error/container-default',
  'button/secondary/error-label': '$mode/error/on-container',
  'button/secondary/error-hover': '$mode/error/container-hover',
  'button/outline/accent-bg': '$mode/accent/on-accent',
  'button/outline/accent-label': '$mode/accent/on-accent',
  'button/outline/accent-hover': '$mode/accent/hover',
  'button/outline/neutral-bg': '$mode/neutral/default',
  'button/outline/neutral-label': '$mode/neutral/default',
  'button/outline/neutral-hover': '$mode/neutral/hover',
  'button/outline/error-bg': '$mode/error/default',
  'button/outline/error-label': '$mode/error/default',
  'button/outline/error-hover': '$mode/error/hover',
  'button/ghost/accent-bg': '$mode/accent/default',
  'button/ghost/accent-label': '$mode/accent/on-accent',
  'button/ghost/accent-hover': '$mode/accent/hover',
  'button/ghost/neutral-label1': '$mode/neutral/default',
  'button/ghost/neutral-label2': '$mode/neutral/on-neutral',
  'button/ghost/neutral-hover': '$mode/neutral/hover',
  'button/ghost/error-label2': '$mode/error/on-error',
  'button/ghost/error-label1': '$mode/error/default',
  'button/ghost/error-hover': '$mode/error/hover',
  'button/dark/neutral-bg': '$theme/color/neutral/neutral-800',
  'button/dark/neutral-label': '$mode/neutral/on-neutral',
  'button/dark/neutral-hover': '$theme/color/neutral/neutral-900',
  'badge/muted/neutral-bg': '$mode/neutral/container-muted',
  'badge/muted/neutral-label': '$mode/neutral/default',
  'badge/muted/neutral-caption': '$mode/neutral/soft',
} as const;
